import type { TActionItemState } from '@model/actionItem';

export const stateTypes: Record<TActionItemState, string> = {
  NEW: 'An action item has just been created and requires a response from a facility technician.',
  'Awaiting Update': 'The facility needs to respond with additional information about the action item.',
  'Needs Response':
    'Waites analysts have provided additional information that requires a response from a facility technician.',
  Waiting: 'A facility technician has submitted a comment/question for Waites analysts to review.',
  Snoozed:
    'An action item has been snoozed by a facility technician until a user-specified date. Snooze period will end:',
  Verifying:
    'A facility technician has submitted a completion report. Waites analysts will monitor readings in the coming days to verify everything returns to normal.',
  Archived: '',
};
